import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'

import {resolveHelpURL} from '../../../utils/url'
import styles from '../../packages/Hints/HintItems/HintItems.css'
import {HINT_CATEGORY, toHintId} from '../../packages/Hints/Hints.types'
import type {Hint} from '../../packages/Hints/Hints.types'

export const favoritesHint: Hint = {
  id: toHintId('favorites-sidebar-section'),
  category: HINT_CATEGORY.sidebar,
  name: 'Favorites',
  text: 'Quickly access the projects and build configurations you’ve added to favorites.',
  helpLink: resolveHelpURL('?Favorite+Build'),
  directions: [Directions.RIGHT_BOTTOM],
  className: styles.favoritesHint,
}
